import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'gatsby';
import SVG from 'react-inlinesvg';
import companyData from '../data/company';

import PreTitle from './PreTitle';
import Newsletter from './Newsletter';

import BackgroundSrc from '../img/svg/footer_bg.svg';

import Badge1PNG from '../img/png/getindata-top-development-company-clutch.png';
import Badge1WEBP from '../img/webp/getindata-top-development-company-clutch.webp';
import Badge2PNG from '../img/png/getindata-top-it-and-business-services-company-clutch.png';
import Badge2WEBP from '../img/webp/getindata-top-it-and-business-services-company-clutch.webp';
import Badge3PNG from '../img/png/getindata-big-data-consultants-clutch.png';
import Badge3WEBP from '../img/webp/getindata-big-data-consultants-clutch.webp';
import Badge4PNG from '../img/png/gc-partner-badge.png';
import Badge4WEBP from '../img/webp/gc-partner-badge.webp';

import IconMessageSrc from '../img/svg/icons/message.svg';
import IconPhoneSrc from '../img/svg/icons/phone.svg';
import IconPinSrc from '../img/svg/icons/pin.svg';
import IconGithubSrc from '../img/svg/icons/github.svg';
import IconLinkedinSrc from '../img/svg/icons/linkedin.svg';
import IconTwitterSrc from '../img/svg/icons/twitter.svg';
import IconFacebookSrc from '../img/svg/icons/facebook.svg';
import IconMediumSrc from '../img/svg/icons/medium.svg';
import IconClutchSrc from '../img/svg/icons/clutch.svg';
import IconYoutubeSrc from '../img/svg/icons/youtube.svg';
import IconSpotifySrc from '../img/svg/icons/spotify.svg';

function FooterTemplate({
  className,
  registeredAddress,
  registrationNumber,
  socials,
  menuItems,
  email,
  phoneNumber
}) {
  const classes = classNames(className, 'Footer');

  return (
    <footer className={classes} id="footer">
      <div className="Footer__container">
        <div className="Footer__background">
          <SVG
            src={BackgroundSrc}
          />
        </div>
        <div className="Footer__row">
          <div className="Footer__row__col">
            <PreTitle 
              className="Footer__subTitle"
              title={'Newsletter'}
              variants={['white']}
            />

            <Newsletter />
          </div>
          <div className="Footer__row__col">
            <div className="Footer__badges">
              <a
                href="https://clutch.co/profile/getindata"
                rel="noopener noreferrer"
                target="_blank"
                className="Footer__badge"
              >
                <picture>
                  <source srcSet={Badge1WEBP} type="image/webp" />
                  <source srcSet={Badge1PNG} type="image/png" /> 
                  <img src={Badge1PNG} alt="Clutch Top IoT Developers" />
                </picture>
              </a>

              <a
                href="https://clutch.co/profile/getindata"
                rel="noopener noreferrer"
                target="_blank"
                className="Footer__badge"
              >
                <picture>
                  <source srcSet={Badge2WEBP} type="image/webp" />
                  <source srcSet={Badge2PNG} type="image/png" /> 
                  <img src={Badge2PNG} alt="Clutch Top BI & Big Data Consultants" />
                </picture>
              </a>

              <a
                href="https://clutch.co/profile/getindata"
                rel="noopener noreferrer"
                target="_blank"
                className="Footer__badge"
              >
                <picture>
                  <source srcSet={Badge3WEBP} type="image/webp" />
                  <source srcSet={Badge3PNG} type="image/png" /> 
                  <img src={Badge3PNG} alt="Clutch Clients’ say we deliver" />
                </picture>
              </a>
              
              <a
                href="https://cloud.withgoogle.com/partners/detail/?id=getindata&hl=pl-PL"
                rel="noopener noreferrer"
                target="_blank"
                className="Footer__badge"
              >
                <picture>
                  <source srcSet={Badge4WEBP} type="image/webp" />
                  <source srcSet={Badge4PNG} type="image/png" /> 
                  <img src={Badge4PNG} alt="Google Cloud Partner Logo" />
                </picture>
              </a>
            </div>
          </div>
        </div>

        <div className="Footer__row">
          <div className="Footer__row__col Footer__row__col--between">
            <div>
              <PreTitle 
                className="Footer__subTitle"
                title={'Contact us'}
                variants={['white']}
              />

              <div className="Footer__info">
                <SVG className="Footer__info__img" src={IconPhoneSrc} />
                <div className="Footer__info__text">
                  <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                </div>
              </div>

              <div className="Footer__info">
                <SVG className="Footer__info__img" src={IconMessageSrc} />
                <div className="Footer__info__text">
                  <a href={`mailto:${email}`}>{email}</a>
                </div>
              </div>

              <div className="Footer__info">
                <SVG className="Footer__info__img" src={IconPinSrc} />
                <div className="Footer__info__text Footer__info__text--address">
                  {registeredAddress.street},
                  <br/> 
                  {registeredAddress.city}, {registeredAddress.country}
                  <br/>
                  <div className="Footer__info__text Footer__info__text--reg">
                    Company registration no. {registrationNumber}
                  </div>
                </div>
              </div>
            </div>

            <div className="Footer__socials">
              <a
                href={socials.linkedin}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconLinkedinSrc} />
              </a>

              <a
                href={socials.github}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconGithubSrc} />
              </a>

              <a
                href={socials.facebook}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconFacebookSrc} />
              </a>

              <a
                href={socials.twitter}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconTwitterSrc} />
              </a>

              <a
                href={socials.medium}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconMediumSrc} />
              </a>

              <a
                href={socials.clutch}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconClutchSrc} />
              </a>

              <a
                href={socials.clutch}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconYoutubeSrc} />
              </a>

              <a
                href={socials.clutch}
                rel="noopener noreferrer"
                className="Footer__social"
                target="_blank"
              >
                <SVG src={IconSpotifySrc} />
              </a>
            </div>
          </div>
          <div className="Footer__row__col">
            <div className="Footer__rowNav">
              <div className="Footer__rowNav__col">
                <div className="Footer__nav">
                  <Link to="/" target="_blank" className="Footer__nav__linkMain">
                    Home
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/big-data-solutions" target="_blank" className="Footer__nav__linkMain">
                    Solutions
                  </Link>
                  <ul>
                    {menuItems && menuItems[0].dropdown.map((e, i) =>
                      <li key={i}>
                        <Link to={e.to} target="_blank" className="Footer__nav__link" key={e.label}>
                        {e.label}
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div className="Footer__rowNav__col">
                <div className="Footer__nav">
                  <Link to="/services" target="_blank" className="Footer__nav__linkMain">
                    Services
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/big-data-training" target="_blank" className="Footer__nav__linkMain">
                    Training
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/company" target="_blank" className="Footer__nav__linkMain">
                    Company
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/blog" target="_blank" className="Footer__nav__linkMain">
                    Blog
                  </Link>
                </div>
              </div>
              <div className="Footer__rowNav__col">
                <div className="Footer__nav">
                  <Link to="/careers" target="_blank" className="Footer__nav__linkMain">
                    Careers
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/privacy" target="_blank" className="Footer__nav__linkMain">
                    Privacy Policy
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/cookies" target="_blank" className="Footer__nav__linkMain">
                    Cookies
                  </Link>
                </div>
                <div className="Footer__nav">
                  <Link to="/estimate" target="_blank" className="Footer__nav__linkMain">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const Footer = ({ className = '', menuItems}) => {
  return <FooterTemplate className={className} menuItems={menuItems} {...companyData} />;
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
